import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    machines: [],
    errors: {},
    loading: false,
}

export const dataSlice = createSlice({
    name: 'data',
    initialState,
    reducers: {
        setErrors: (state, action) => {
            state.errors = action.payload
        },
        clearErrors: (state) => {
            state.errors = {}
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setMachines: (state, action) => {
            state.machines = action.payload
        },
        addMachine: (state, action) => {
            state.machines.push(action.payload)
        },
        updateMachine: (state, action) => {
            const index = state.machines.findIndex(m => m.id === action.payload.id)
            if (index !== -1) {
                state.machines[index] = action.payload
            }
        },
        deleteMachine: (state, action) => {
            state.machines = state.machines.filter(m => m.id !== action.payload)
        },
    },
})

export const { setErrors, clearErrors, setLoading, setMachines, addMachine, updateMachine, deleteMachine } = dataSlice.actions

export default dataSlice.reducer